import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { Card } from "@/components/ui/Card";
import { Skeleton } from "@/components/ui/Skeleton";
import { cn } from "@/lib/cn";
import {
  buildDataQualityReasons,
  confidenceLabel,
  dataQualityDotClass,
  dataQualityTip,
} from "./utils";

export function DataQualityCard() {
  const engineState = useQuery(api.engine.getEngineState, {});

  if (engineState === undefined) {
    return <Skeleton className="h-32 rounded-2xl" data-testid="data-quality-loading" />;
  }
  if (engineState === null) return null;

  const reasons = buildDataQualityReasons(engineState);
  const tip = dataQualityTip(engineState);

  return (
    <Card className="flex flex-col gap-3 p-4" data-testid="data-quality-card">
      <div className="flex items-center justify-between gap-3">
        <h3 className="text-base font-semibold text-text">Plan data quality</h3>
        <span className="flex items-center gap-1.5 text-xs font-semibold text-text" data-testid="data-quality-label">
          <span aria-hidden className={cn("inline-block h-2 w-2 rounded-full", dataQualityDotClass(engineState.dataQuality))} />
          {confidenceLabel(engineState.dataQuality)}
        </span>
      </div>
      {reasons.length > 0 && (
        <ul className="flex flex-col gap-1.5 text-xs leading-relaxed text-text-muted">
          {reasons.map((reason) => (
            <li key={reason} className="flex items-start gap-2">
              <span aria-hidden className="mt-1.5 inline-block h-1 w-1 shrink-0 rounded-full bg-text-muted/60" />
              {reason}
            </li>
          ))}
        </ul>
      )}
      <p className="rounded-xl bg-accent-light/60 px-3 py-2 text-xs leading-relaxed text-accent-dark" data-testid="data-quality-tip">
        {tip}
      </p>
    </Card>
  );
}
